import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby"
import RecentPostsCarousel from "../ui/recent-posts-carousel";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components";
import { Link } from "gatsby"

const RecentPostsBlock = styled.div`
    h3 {
        font-family: ${(props) => props.theme.fontTurmoil}; 
        border-bottom: 3px solid ${(props) => props.theme.colors.primary};
            padding-bottom: 1rem;
    }

    p {
        margin: 1rem 0 0;
    }
    a {
        text-decoration: none;
    }
    span {
        font-family: ${(props) => props.theme.fontCondensed};
        display: block;
        margin-bottom: 2rem;
    }
`;

const Button = styled(Link)`
font-family: ${(props) => props.theme.fontCondensed};
  font-size: 1rem;
  padding: 0.5rem 2rem;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  text-decoration: none;
  transition: 0.3s;
  position: relative;
  &:hover {
    background: ${props => props.theme.colors.primary};
    border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem 2rem;
    font-size: 1rem;
  }
`

const RecentPosts = () => {
    const data = useStaticQuery(graphql`{
        allContentfulWhatsOn(sort: { fields: publishedDate, order: ASC }) {
                edges {
                    node {
                        title
                        slug
                        id
                        publishedDate(formatString: "Do MMMM, YYYY")
                        featuredImage {
                            gatsbyImageData(
                                width: 200
                                height: 150
                                placeholder: BLURRED
                                layout: CONSTRAINED
                            )
                        }
                        standfirst {
                            childMarkdownRemark {
                                excerpt(pruneLength: 40)
                            }
                        }
                    }
                }
            }
        }
    `)

        // if (data.allContentfulWhatsOn.featuredImage === null) {
        //     var featuredImageTrue = false;
        // }
        // else if (data.allContentfulWhatsOn.featuredImage != null) {
        //     var featuredImageTrue = true;
        // }
        //console.log(data.allContentfulWhatsOn.edges.node.title);
    
  return (
    <RecentPostsBlock>
        <h3>LATEST NEWS STORIES</h3>
        <RecentPostsCarousel>
           
                {data.allContentfulWhatsOn.edges.map(
                    (posts, index) => (
                        <React.Fragment key={index}>
                                <Link to={`/news/${posts.node.slug}/`} id={'id' + posts.node.id}>
                                   
                                    <GatsbyImage image={posts.node.featuredImage.gatsbyImageData} />

                                    <p>{posts.node.title}</p>
                                    <span>{posts.node.standfirst.childMarkdownRemark.excerpt}</span>
                                    <Button to={`/news/${posts.node.slug}/`}>
                                        Read more...
                                    </Button>
                                </Link>

                        </React.Fragment>
                    )
                )}
        </RecentPostsCarousel>
    </RecentPostsBlock>
  );
};

export default RecentPosts;

